// styling
import "./stylesheets";

// packages
import "regenerator-runtime/runtime";
import "bootstrap";

// helpers / custom logic
import "./ai-correction";
import "./alert-buttons";
import "./audio-recorder";
import "./custom";
import "./dataLayer";
import "./flip-cards";
import './media-embed';
import "./newsletter-signup";
import "./profile";
import "./sliders";
import "./smooth-scroll";
import "./target-blank-for-outside-domain";
import "./text-to-speech";
